__turbopack_context__.v({
  "actionArea": "heroHomeTemplate-module-scss-module__J3xKpq__actionArea",
  "badgeIcon": "heroHomeTemplate-module-scss-module__J3xKpq__badgeIcon",
  "buttonRow": "heroHomeTemplate-module-scss-module__J3xKpq__buttonRow",
  "content": "heroHomeTemplate-module-scss-module__J3xKpq__content",
  "ctaContainer": "heroHomeTemplate-module-scss-module__J3xKpq__ctaContainer",
  "description": "heroHomeTemplate-module-scss-module__J3xKpq__description",
  "desktopCarousel": "heroHomeTemplate-module-scss-module__J3xKpq__desktopCarousel",
  "disclaimer": "heroHomeTemplate-module-scss-module__J3xKpq__disclaimer",
  "fdicBadge": "heroHomeTemplate-module-scss-module__J3xKpq__fdicBadge",
  "headline": "heroHomeTemplate-module-scss-module__J3xKpq__headline",
  "headlinePart": "heroHomeTemplate-module-scss-module__J3xKpq__headlinePart",
  "heroEggshellContainer": "heroHomeTemplate-module-scss-module__J3xKpq__heroEggshellContainer",
  "heroHeader": "heroHomeTemplate-module-scss-module__J3xKpq__heroHeader",
  "mailOfferIcon": "heroHomeTemplate-module-scss-module__J3xKpq__mailOfferIcon",
  "mailOfferIconCard": "heroHomeTemplate-module-scss-module__J3xKpq__mailOfferIconCard",
  "mailOfferText": "heroHomeTemplate-module-scss-module__J3xKpq__mailOfferText",
  "mailOfferTextCard": "heroHomeTemplate-module-scss-module__J3xKpq__mailOfferTextCard",
  "mobileList": "heroHomeTemplate-module-scss-module__J3xKpq__mobileList",
  "respondToMailOffer": "heroHomeTemplate-module-scss-module__J3xKpq__respondToMailOffer",
  "respondToMailOfferCard": "heroHomeTemplate-module-scss-module__J3xKpq__respondToMailOfferCard",
  "respondToMailOfferMobile": "heroHomeTemplate-module-scss-module__J3xKpq__respondToMailOfferMobile",
  "starIcon": "heroHomeTemplate-module-scss-module__J3xKpq__starIcon",
  "subDescription": "heroHomeTemplate-module-scss-module__J3xKpq__subDescription",
  "subheadGroup": "heroHomeTemplate-module-scss-module__J3xKpq__subheadGroup",
  "trustPilot": "heroHomeTemplate-module-scss-module__J3xKpq__trustPilot",
});
